import clsx from 'classnames'
import moment from 'moment'
import { Fragment } from 'react'
import { MdHighlightOff } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { getLink, igaoPages, igaoPagesOrder } from '../igao/utils'

import styles from './new-claims-warning.module.css'

interface UnsavedDraftsProps {
  drafts?: Draft[]
  patientId: string
  clientName: string
}

interface Draft {
  path: string
  created: string
  updated: string
}

export function UnsavedDrafts ({ drafts = [], clientName, patientId }: UnsavedDraftsProps): JSX.Element | null {
  if (!drafts.length) {
    return null
  }

  return (
    <div className={clsx(styles.wrapper, styles.error)}>
      <div className={styles.iconColumn}>
        <MdHighlightOff className={styles.icon} />
      </div>

      <div className={styles.contentColumn}>
        <div className={styles.row}>
          <h2 className={styles.title}>
            Unsaved Drafts Found
          </h2>
        </div>

        <div className={styles.row}>
          <p className={styles.p}>
            This Encounter cannot be Signed until unsaved drafts are Published
            or Canceled. Please use the links below to identify where unsaved
            drafts have been detected and either cancel or publish them and
            then return here to Sign.
          </p>
        </div>

        <div className={styles.row}>
          <div className={styles.grid}>
            {/* @ts-expect-error //it's okay */}
            {drafts?.sort((a, b) => igaoPagesOrder[a.path] - igaoPagesOrder[b.path])?.map((draft) => {
              let { name } = [
                ...igaoPages,
                { id: 'current-pregnancy', name: 'Current Pregnancy' },
                { id: 'obstetrical-history', name: 'Obstetrical History' }
              ].find(page => page.id === draft.path) ?? {}
              let link = getLink(patientId, draft.path, clientName)

              if (draft.path === 'behavioral') {
                name = 'Behavioral Health'
                link = `/patient/${clientName}/${patientId}/assessment/standardbehavioral`
              }

              return (
                <Fragment
                  key={draft.path}
                >
                  <Link
                    to={link}
                    className={styles.link}
                  >
                    {name}
                  </Link>

                  <span className={styles.count}>
                    {moment(draft.updated).format('LLL')}
                  </span>
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
